// 插件路由
const routes = [
	{ 
        path: '/debt', 
        component: () => import(/* webpackChunkName: "debt" */ '~/addon/debt/pages/debt.vue') 
    },
]

export default routes;



// WEBPACK FOOTER //
// ./src/addon/debt/router/index.js